import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function itemRender(t, handlePageChange, currentPage, prevPage, nextPage, page, type, originalElement) {
 
  if (type === "prev") {
    return <a onClick={() => handlePageChange(currentPage - 1)} disabled={!prevPage}>{t("Previous")}</a>;
  }
  if (type === "next") {
    return <a onClick={() => handlePageChange(currentPage + 1)} disabled={!nextPage}>{t("Next")}</a>;
  }
  if (type === "page") {
    return <a onClick={() => handlePageChange(page)}>{page}</a>;
  }
  return originalElement;
}

export function onShowSizeChange() {
  // console.log(current, pageSize);
}
export const showTotal = (t,total, range) =>{

  return (
    `${t("Showing")} ${range[0]} ${t("to")} ${range[1]} ${t("of")} ${total} ${t("entries")}`
  );
}